"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable arrow-body-style, max-len, @typescript-eslint/no-unused-vars */

var react_1 = __importDefault(require("react"));

var lodash_1 = require("lodash");

var core_1 = require("@bodiless/core");

var fclasses_1 = require("@bodiless/fclasses");

var components_1 = require("@bodiless/components");

var FilterByGroupContext_1 = require("./FilterByGroupContext");

var token_1 = require("./token");

var Accordion_1 = require("../Accordion");

var tagTitleComponentsStart = {
  FilterInputWrapper: fclasses_1.Div,
  FilterGroupItemInput: fclasses_1.Input,
  FilterGroupItemPlaceholder: fclasses_1.Label,
  FilterGroupItemLabel: fclasses_1.Label
};

var withUnselectOnDelete = function withUnselectOnDelete(Component) {
  return function (props) {
    var _a = FilterByGroupContext_1.useFilterByGroupContext(),
        setSelectedNode = _a.setSelectedNode,
        setSelectedTag = _a.setSelectedTag;

    var onDelete = function onDelete(deletedItem) {
      setSelectedTag();
      setSelectedNode();
    };

    return react_1.default.createElement(Component, __assign({}, props, {
      onDelete: onDelete
    }));
  };
};

var TagTitleBase = function TagTitleBase(_a) {
  var components = _a.components,
      _b = _a.emptyTitleText,
      emptyTitleText = _b === void 0 ? 'Select Tag...' : _b,
      rest = __rest(_a, ["components", "emptyTitleText"]);

  var FilterGroupItemInput = components.FilterGroupItemInput,
      FilterGroupItemLabel = components.FilterGroupItemLabel,
      FilterGroupItemPlaceholder = components.FilterGroupItemPlaceholder,
      FilterInputWrapper = components.FilterInputWrapper;

  var _c = components_1.useTagsAccessors(),
      tag = _c.tag,
      nodeId = _c.nodeId;

  var _d = FilterByGroupContext_1.useFilterByGroupContext(),
      selectedTag = _d.selectedTag,
      selectedNode = _d.selectedNode,
      setSelectedNode = _d.setSelectedNode,
      setSelectedTag = _d.setSelectedTag;

  var onSelect = function onSelect() {
    setSelectedNode(nodeId);
    setSelectedTag(tag);
  };

  var isSelectedTagUpdated = selectedTag && selectedNode && nodeId === selectedNode && tag.id !== selectedTag.id;

  if (isSelectedTagUpdated) {
    setSelectedTag(tag);
    setSelectedNode(nodeId);
  }

  var isTagSelected = Boolean(selectedTag && selectedTag.id === tag.id);
  var isNodeSelected = Boolean(selectedNode === nodeId);
  return react_1.default.createElement(FilterInputWrapper, __assign({}, rest, {
    key: tag.id
  }), react_1.default.createElement(FilterGroupItemInput, {
    type: "radio",
    name: "filter-item",
    value: tag.id,
    id: nodeId,
    onChange: function onChange() {
      return onSelect();
    },
    checked: isNodeSelected && isTagSelected
  }), lodash_1.isEmpty(tag.name) ? react_1.default.createElement(FilterGroupItemPlaceholder, {
    htmlFor: nodeId
  }, emptyTitleText) : react_1.default.createElement(FilterGroupItemLabel, {
    htmlFor: nodeId
  }, tag.name));
};

var TagTitle = lodash_1.flow(core_1.withoutProps(['componentData', 'onContextMenu', 'getSuggestions', 'allowMultipleTags', 'noSuggestionsText', 'seeAllText', 'formTitle', 'formBodyText', 'selectedTags', 'registerSuggestions']), core_1.ifEditable(components_1.withTagButton, core_1.withContextActivator('onClick'), core_1.withLocalContextMenu), core_1.ifReadOnly(core_1.withoutProps(['setComponentData'])), FilterByGroupContext_1.withTagProps({
  allowMultipleTags: false,
  placeholder: 'Add or Create',
  formTitle: 'Group Membership',
  formBodyText: 'Select from available groups:',
  seeAllText: 'View All Groups',
  noSuggestionsText: 'No matching groups found.'
}), core_1.withNodeDataHandlers({
  tags: []
}), core_1.withNode, core_1.withNodeKey('tag'), fclasses_1.designable(tagTitleComponentsStart, 'TagTitle'))(TagTitleBase);
var TestFilterComponentsStart = {
  CategoryList: lodash_1.flow(components_1.asEditableList, fclasses_1.withDesign({
    Title: lodash_1.flow(fclasses_1.replaceWith(fclasses_1.H3), components_1.asEditable('category_name', 'Category Name')),
    Item: fclasses_1.stylable,
    Wrapper: fclasses_1.stylable
  }))(components_1.List),
  TagList: lodash_1.flow(withUnselectOnDelete, components_1.asEditableList, fclasses_1.withDesign({
    Title: fclasses_1.replaceWith(TagTitle),
    Wrapper: fclasses_1.stylable
  }))(components_1.List)
};

var FilterBase =
/** @class */
function (_super) {
  __extends(FilterBase, _super);

  function FilterBase(props) {
    var _this = _super.call(this, props) || this;

    _this.Filter = fclasses_1.Div;
    _this.RestProps = {};

    var components = props.components,
        rest = __rest(props, ["components"]);

    var TagList = components.TagList,
        CategoryList = components.CategoryList;
    var AccordionTagList = token_1.asExpandedOnDesktopBody(TagList);
    _this.RestProps = rest;
    _this.Filter = lodash_1.flow(components_1.ifViewportIs(['lg', 'xl', 'xxl'])(components_1.withBasicSublist(TagList)), components_1.ifViewportIsNot(['lg', 'xl', 'xxl'])(Accordion_1.withAccordionSublist(AccordionTagList)))(CategoryList);
    return _this;
  }

  FilterBase.prototype.render = function () {
    return react_1.default.createElement(this.Filter, __assign({}, this.RestProps));
  };

  return FilterBase;
}(react_1.default.PureComponent);

var FilterClean = lodash_1.flow(core_1.withNodeKey('filter'), fclasses_1.designable(TestFilterComponentsStart, 'Filter'))(FilterBase);
exports.default = FilterClean;